import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestNews from './components/LatestNews';
import HotPlots from './components/HotPlots';
import SiteIntroBand from './components/SiteIntroBand';

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestNews />
      <HotPlots />
      <SiteIntroBand />
    </>
  );
}